import { useMutation } from '@tanstack/react-query'
import { useStore } from '@tanstack/react-store'
import { api } from 'api'
import { userIdentificationLabel } from 'shared/constants/user'
import { userListStore } from 'shared/store/userList'
import { checkParam } from 'shared/utils/checkParam'
import {
  getDateReadFormat,
  getDateTimeReadFormat,
  getDateTimeToSubmit,
} from 'shared/utils/dateFormatting'
import { exportExcelFile } from 'shared/utils/exportExcelFile'
import { toaster } from 'uikit/Toaster'
import { columns } from './columns'

export const useFetchData = (size: any) => {
  const filter = useStore(userListStore, (s) => s.filter)

  const payload = {
    size,
    page: 0,
    lastName: checkParam(filter?.lastName),
    firstName: checkParam(filter?.firstName),
    middleName: checkParam(filter?.middleName),
    phone: checkParam(filter?.phone),
    clientId: checkParam(filter?.clientId),
    passportNumber: checkParam(filter?.passportNumber),
    applicationVersion: checkParam(filter?.applicationVersion),
    platform: checkParam(filter?.platform),
    identification: checkParam(filter?.identification),
    identificationDateFrom: checkParam(getDateTimeToSubmit(filter?.identificationDateFrom)),
    identificationDateTo: checkParam(getDateTimeToSubmit(filter?.identificationDateTo)),
    registrationDateFrom: checkParam(getDateTimeToSubmit(filter?.registrationDateFrom)),
    registrationDateTo: checkParam(getDateTimeToSubmit(filter?.registrationDateTo)),
  }

  return useMutation({
    mutationFn: () => api.users.fetchUserList(payload),
    onError: (error) => {
      toaster.create({
        title: 'Не удалось получить список пользователей',
        description: error?.message,
        type: 'error',
      })
    },
    onSuccess: (response) => {
      const _data = response?.users?.map((i: any) => ({
        ...i,
        createDate: getDateTimeReadFormat(i.createDate),
        identificationDate: getDateTimeReadFormat(i.identificationDate),
        birthDate: getDateReadFormat(i.birthDate),
        identification: userIdentificationLabel[i.identification] || i.identification,
      }))
      exportExcelFile(_data, {
        sheetName: 'Users',
        columns,
      })
    },
  })
}
